import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import BaseModal from '../utils/BaseModal/BaseModal';
import { notifyError, notifyInfo } from '../../../utils/notify';
import { ButtonWrapper, CancelButton, Form, SubmitButton } from './NewCollectionFormModal.styles';
import Input from '../../utils/inputs/Input/Input';
import { useDispatch, useSelector } from 'react-redux';
import { createCollection } from '../../../store/slices/collections/asyncThunks';
import { selectCollectionsActionsPending } from '../../../store/slices/collections/slice';

export const createCollectionFormSchema = yup
  .object({ name: yup.string().trim().required('Name is required') })
  .required();

const NewCollectionFormModal = ({ modalRef, onSuccess, influencerId }) => {
  const dispatch = useDispatch();
  const { createCollection: createCollectionPending } = useSelector(selectCollectionsActionsPending);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: '',
    },
    delayError: 300,
    resolver: yupResolver(createCollectionFormSchema),
  });

  const onSubmit = data => {
    let { name } = data;

    dispatch(createCollection({ name, ...(influencerId && { influencerId }) }))
      .unwrap()
      .then(() => {
        modalRef.current.hide();
        onSuccess();
        notifyInfo('Collection created successfully!');
      })
      .catch(err => {
        notifyError(err.message);
      });
  };

  return (
    <BaseModal
      title="Add New Collection"
      ref={modalRef}
      onClose={() => {
        modalRef.current.hide();
      }}
      onAfterClose={() => {
        reset();
      }}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Input label="Name" placeholder="Enter name" {...register('name')} error={errors.name?.message} />
        <ButtonWrapper>
          <CancelButton
            title="Cancel"
            onClick={() => {
              reset();
              modalRef.current.hide();
            }}
            type="button"
          />
          <SubmitButton type="submit" title="Save" isLoading={createCollectionPending} />
        </ButtonWrapper>
      </Form>
    </BaseModal>
  );
};

export default NewCollectionFormModal;
